
export const services = {
  hero: {
    description: 'COMPREHENSIVE ENERGY SOLUTIONS FOR GAS, ELECTRICITY AND BUSINESS CONSULTING SERVICES'
  },
  list: {
    title: 'Our Service Categories',
    subtitle: 'Professional energy solutions tailored to your business needs'
  },
  gas: {
    title: 'GAS',
    smallBusiness: {
      title: 'Small businesses',
      rights: 'Information on the rights and obligations of the final gas customer.',
      checklist: 'Checklist for the European energy consumer'
    },
    otherBusiness: {
      title: 'Other business entities',
      rights: 'Information on the rights and obligations of the final gas customer',
      checklist: 'Checklist for the European energy consumer.'
    },
    households: {
      title: 'Households',
      rights: 'Information on the rights and obligations of the final gas customer',
      checklist: 'Checklist for the European energy consumer.'
    }
  },
  electricity: {
    title: 'ELECTRICITY',
    smallBusiness: {
      title: 'Small businesses',
      rights: 'Information on the rights and obligations of the final electricity customer',
      checklist: 'Checklist for the European energy consumer.',
      environmental: 'Environmental impact of electricity production purchased or produced by the supplier for the purpose of its supply to electricity customers.',
      impact: 'Information on the environmental impact of electricity production'
    },
    otherBusiness: {
      title: 'Other business entities',
      rights: 'Information on the rights and obligations of the final electricity customer',
      checklist: 'Checklist for the European energy consumer',
      environmental: 'Environmental impact of electricity production purchased or produced by the supplier for the purpose of its supply to electricity customers',
      impact: 'Information on the environmental impact of electricity production'
    },
    households: {
      title: 'Households',
      rights: 'Information on the rights and obligations of the final gas customer',
      checklist: 'Checklist for the European energy consumer.'
    }
  },
  consulting: {
    title: 'BUSINESS CONSULTING',
    services: {
      title: 'Consulting Services',
      strategic: 'Strategic business planning and market analysis',
      operational: 'Operational efficiency and process optimization',
      compliance: 'Regulatory compliance and risk management',
      market: 'Market entry strategies and business development'
    }
  }
};
